// WHO IS CALLING, ACROSS EVERY CHANNEL (Stage 4.5, the owner's design 2026-10-26) — what the ring popup's short briefing says in
// the seconds a phone rings, and the order the call panel's history reads in. Pure, so scripts/check-handoffs.cjs can prove it.
// The data is the server's (server/ai/callerBriefing.js), already cut to what this agent may see.

export const RING_FACTS = 4;
export const PANEL_HISTORY = 6;

// The name the screens show: the CRM's, else the caller profile's — never invented.
export const callerName = (briefing, profile = null) => briefing?.contact?.name || profile?.name || null;

// An order's stage in the orders board's own words ("ready" for a delivery is "on the way" there too).
export const stageKey = (o) => (o?.status === "ready" && o?.fulfilment === "delivery" ? "stage_ready_delivery" : `stage_${o?.status}`);

// The facts, most pressing first: what is happening now (an open order, the next appointment, open tickets), then when they were
// last in touch, then a follow-up promised to them. At most four, a few words each. The time words are the screen's own helpers.
export function ringFacts(briefing, { t, dayAndTime, relativeTime }) {
  const open = briefing?.open ?? null;
  const out = [];
  const order = open?.orders?.[0];
  if (order) {
    const more = open.orders.length > 1 ? ` +${open.orders.length - 1}` : "";
    out.push({ key: "order", kind: "order", text: `${order.ref} · ${t(`orders:${stageKey(order)}`)}${more}` });
  }
  if (open?.appointment?.startAt) out.push({ key: "appointment", kind: "appointment", text: t("handoff:briefing.appointment", { when: dayAndTime(open.appointment.startAt) }) });
  if (open?.ticketsOpen > 0) out.push({ key: "tickets", kind: "ticket", text: t("handoff:briefing.ticketsOpen", { count: open.ticketsOpen }) });
  const last = briefing?.lastContact;
  if (last?.at) out.push({ key: "last", kind: last.channel, text: t("handoff:briefing.lastContact", { channel: t(`handoff:briefing.channel_${last.channel}`), when: relativeTime(last.at) }) });
  const fu = open?.followUps?.[0];
  if (fu?.dueAt) out.push({ key: "followUp", kind: "followUp", text: t("handoff:briefing.followUpDue", { ref: fu.ref, when: dayAndTime(fu.dueAt) }) });
  return out.slice(0, RING_FACTS);
}

// The call panel's history: the calls as the screen has always listed them, and the WhatsApp conversations the briefing holds,
// newest first. A row with no readable time sinks to the bottom rather than vanishing.
export function mergedHistory(calls = [], whatsapp = [], max = PANEL_HISTORY) {
  const at = (v) => { const d = new Date(v); return Number.isFinite(+d) ? +d : 0; };
  return [
    ...(calls ?? []).map((c, i) => ({ key: `call-${c?.UniqueId ?? i}`, type: "call", at: at(c?.startTime), call: c })),
    ...(whatsapp ?? []).map((w, i) => ({ key: `wa-${w?.recordId ?? w?.conversationId ?? i}-${i}`, type: "whatsapp", at: at(w?.at), wa: w })),
  ].sort((a, b) => b.at - a.at).slice(0, max);
}

// Anything open to show in the panel's "Open now" column (the ticket keeps its own block below it).
export const hasOpenItems = (open) => !!(open && ((open.orders?.length ?? 0) || open.appointment || (open.followUps?.length ?? 0)));
